import { Theme } from "@mui/material";

export const senecFormHelperTextTheme = (theme: Theme) => ({
    styleOverrides: {
        root: {
            ...theme.typography.s1,
            variant: "body1",
            letterSpacing: "normal",
        },
    },
});
